import React, { useMemo } from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedNumber, FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { InventoryStatusIcon } from './inventory-status-icon';
import { shipmentItemInventoryStatus } from '../../../../fulfillment-plan/sections/shipment-items/helpers/get-item-inventory-status';
import messages from '../../messages';

import style from './item-stock.module.less';

const InventoryStatusClassNameMap = {
  [shipmentItemInventoryStatus.hasLowStock]: style['low-stock-level'],
  [shipmentItemInventoryStatus.isAllocated]: style['is-allocated'],
  [shipmentItemInventoryStatus.isAvailable]: style['is-available'],
};

export const AvailableStockLevel = ({
  shouldShowInventoryInfoUiTreatments = false,
  status = shipmentItemInventoryStatus.isAvailable,
  quantity = 0,
}) => {
  const inventoryStatusClassName = shouldShowInventoryInfoUiTreatments ? InventoryStatusClassNameMap[status] : undefined;

  const messageValues = useMemo(
    () => (
      <>
        {shouldShowInventoryInfoUiTreatments && <InventoryStatusIcon status={status} />}
        <FormattedMessage {...messages.available} />
      </>
    ),
    [shouldShowInventoryInfoUiTreatments, status],
  );

  return (
    <div className={style['stock-level-container']}>
      <Text
        className={classnames(style['stock-level-label'], inventoryStatusClassName)}
        element='label'
        textType={TextType.Caption}
        value={messageValues}
      />
      <Text
        className={classnames(style['stock-level'], inventoryStatusClassName)}
        element='span'
        textType={TextType.Caption}
        value={<FormattedNumber value={quantity} />}
      />
    </div>
  );
};

AvailableStockLevel.propTypes = {
  shouldShowInventoryInfoUiTreatments: PropTypes.bool,
  status: PropTypes.oneOf(Object.values(shipmentItemInventoryStatus)),
  quantity: PropTypes.number,
};
